import * as React from 'react';

function SvgAlertCircle(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15.38a.961.961 0 110-1.922.961.961 0 010 1.922zm1.044-9.67l-.276 5.865a.77.77 0 01-1.538 0l-.276-5.862V7.71a1.045 1.045 0 112.088 0h.002z" })));
}

export default SvgAlertCircle;
